<template>
  <div class="pricing-root flex flex-col justify-center w-full">
    <PricingPlans class="py-16" />

    <Ribbon v-bind="ribbonData" variant="gray" class="mb-16" />
  </div>
</template>

<script>
import {
  defineComponent,
  onBeforeMount,
  useMeta,
} from '@nuxtjs/composition-api';
import Ribbon from '@/components/Ribbon.vue';
import PricingPlans from '@/modules/InformationPages/Pricing/components/PricingPlans.vue';
import useGlobalSettings from '@/hooks/useGlobalSettings';

export default defineComponent({
  name: 'PricingRoot',
  components: {
    PricingPlans,
    Ribbon,
  },
  setup() {
    const { setHeader } = useGlobalSettings();

    onBeforeMount(() => {
      setHeader({
        header: `Pricing and Plans`,
        subheader: null,
        heroImage: null,
        metaTitle: `Pricing and Plans`,
        registration: false,
        noHero: false,
      });
    });

    useMeta(() => ({ title: `Pricing and Plans` }));

    return {
      ribbonData: {
        title: 'Schedule an Overview Call',
        subtitle: 'Learn how Bambee can help your business',
        cta: 'Schedule Overview Call',
      },
    };
  },
  head() {},
});
</script>
